import { Alert, Button, Card, Checkbox, DatePicker, Form, Input, Modal, Radio, Select, Space, Switch, Tag, Table } from 'antd'
import React, { useEffect, useState } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import InfoView from '../../components/InfoView'
import { FETCH_ERROR } from '../../constants/ActionTypes'
import { useDispatch, useSelector } from 'react-redux'
import PhoneInput from 'react-phone-number-input'
import { baseRequest } from '../../util/Api'
import { CheckCircleOutlined, DownOutlined, UpOutlined, WhatsAppOutlined, QuestionCircleOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import { toRupiah } from '../../libs'
import { getRooms, getRoomsGuest } from '../../appRedux/actions/Booking'
import moment from 'moment'
import { daftarAffiliateChecker, daftarDiscountChecker, discountChecker, setErrorMessage } from '../../appRedux/actions'
import { v4 } from 'uuid'
import { getTrainingBundleParticipant } from "../../appRedux/actions/TrainingBundles";

const RegisterPage = (props) => {
  const [showAlert, setShowAlert] = useState(false)
  const [knowFrom, setKnowFrom] = useState([])
  const [rules, setRules] = useState("")
  const [locations, setLocations] = useState([])
  const [trainingOptions, setTrainingOptions] = useState([])
  const [trainings, setTrainings] = useState([])
  const [provinces, setProvinces] = useState([])
  const [shirtSizes, setShirtSizes] = useState([])
  const [componentDisabled, setComponentDisabled] = useState(false)
  const recaptchaRef = React.createRef()
  const dispatch = useDispatch()
  const [form] = Form.useForm()

  const [bookingShown, setBookingShown] = useState(false)
  const [wantToBook, setWantToBook] = useState(false)
  const [rooms, setRooms] = useState([])
  const [checkInDate, setCheckInDate] = useState("")
  const [checkOutDate, setCheckOutDate] = useState("")

  const [showAdvancedFields, setShowAdvancedFields] = useState(false);
  const [inputDiscountCode, setInputDiscountCode] = useState("");
  const [discountPercent, setDiscountPercent] = useState(null);
  const [discountPrice, setDiscountPrice] = useState(null);
  const [discountId, setDiscountId] = useState(null);
  const [inputAffiliateCode, setInputAffiliateCode] = useState("");
  const [affiliatePercent, setAffiliatePercent] = useState(0);
  const [affiliateCode, setAffiliateCode] = useState(null);

  const [selectedTraining, setSelectedTraining] = useState(null);
  const [selectedBundling, setSelectedBundling] = useState(null);
  const [bundlingWarning, setBundlingWarning] = useState(false);

  useEffect(() => {
    baseRequest("get", "/public/daftar", null).then(data => {
      setKnowFrom(data["know_from_where"])
      setRules(data["training_rules"])
      let options = [];
      data["locations"].map((value) => {
        options.push({
          value: value,
          label: value,
        });
      });
      setLocations(options)
      setTrainingOptions(data["training_options"])
      setProvinces(data["provinces"])
      setShirtSizes(data["shirt_sizes"])
    })
  }, [])

  useEffect(() => {
    getAllRooms()
  }, [wantToBook])

  const onFinishFailed = (errorInfo) => { };
  const messageKey = v4();

  const onFinish = (values) => {
    values.recaptcha = recaptchaRef.current.getValue();
    if (!values.recaptcha) {
      dispatch({ type: FETCH_ERROR, payload: "Harap masukkan Captcha!" })
      return false;
    }
    Modal.confirm({
      title: "Konfirmasi",
      content: "Apakah sudah yakin dengan data yang dimasukkan?",
      onOk: () => {
        setComponentDisabled(true)
        recaptchaRef.current.reset();

        values = {
          ...values,
          discount_id: !selectedBundling ? discountId : null,
          affiliate_code: affiliateCode,
          training_bundle_id: selectedBundling ? selectedBundling.training_bundle_id : null,
          training_bundle_training_id: selectedBundling ? selectedBundling.id : null,
          utm_params: localStorage.getItem("utm_params"),
        }
        baseRequest("post", "/public/daftar", null, values).then(data => {
          if (data) {
            setShowAlert(true)
            const elmnt = document.getElementById("alert-message")
            if (elmnt) {
              elmnt.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }
        }).catch(e => {
          setComponentDisabled(false)
          dispatch(setErrorMessage(e, messageKey));
          // dispatch({ type: FETCH_ERROR, payload: e })
        })
      }
    })
  }

  const onChangeTrainingsFilter = async (filter) => {
    if (!filter.start_date || !filter.end_date || !filter.training_option_id)
      return
    filter = {
      ...filter,
      page_size: 10000,
    }
    const { data, meta } = await baseRequest("get", "/public/trainings/", { ...filter, page_size: 10000 })
    setTrainings(data)
    form.setFieldsValue({ training_id: null })
    setSelectedBundling(null);
  }

  function getAllRooms() {
    if (!wantToBook || !form.getFieldValue("training_id"))
      return
    getRoomsGuest(form.getFieldValue("training_id")).then(data => {
      setRooms(data)
      form.setFieldsValue({ room_number: null })
    })
    const training = trainings.find((t) => t.id === form.getFieldValue("training_id"))
    const splitted = training.dates_summary.split(" ")
    const month = splitted[splitted.length - 2]
    const year = splitted[splitted.length - 1]
    const firstDate = splitted[0].replace(/\D/g, '')
    const lastDate = splitted[splitted.length - 3].replace(/\D/g, '')
    const checkIn = moment(firstDate + " " + month + " " + year, "DD MMMM YYYY").subtract(1, 'days').format("dddd, D MMMM YYYY")
    const checkOut = moment(lastDate + " " + month + " " + year, "DD MMMM YYYY").format("dddd, D MMMM YYYY")
    setCheckInDate(checkIn)
    setCheckOutDate(checkOut)
  }

  function onLocationChange() {
    // Fungsi booking sementara dihide dulu
    // if (form.getFieldValue("training_location") &&
    //   form.getFieldValue("training_location").toLowerCase() == "jakarta"
    //   && form.getFieldValue("training_type") == "offline"
    //   && form.getFieldValue("training_id") != null)
    //   setBookingShown(true)
    // else
    setBookingShown(false)
  }

  async function showBundlingOptions(bundle_ids) {
    const data = await getTrainingBundleParticipant(form.getFieldValue("training_option_id"), bundle_ids);
    const dataSource = [];
    data.map(d => {
      d.trainings.map(t => {
        dataSource.push({
          key: t.id,
          id: t.id,
          name: t.name,
          dates_summary: t.dates_summary,
          time_start: t.time_start,
          time_end: t.time_end,
          is_online: t.is_online,
          location: t.location,
          price: d.price,
          training_bundle_id: d.id,
        })
      })
    })
    const modal = Modal.confirm({
      title: "Pilih Bundling",
      centered: true,
      width: 900,
      closable: true,
      icon: <QuestionCircleOutlined />,
      content: <div>
        <Table
          dataSource={dataSource}
          columns={[
            {
              title: 'Name',
              dataIndex: 'name',
              key: 'name',
            },
            {
              title: 'Lokasi',
              dataIndex: 'location',
              key: 'location',
              render: (location, field) => (<>
                {location ? location : <>
                  {field.is_online ?
                    <span style={{ color: "green" }}>ONLINE</span>
                    :
                    <span style={{ color: "blue" }}>OFFLINE</span>}
                </>
                }
              </>),
            },
            {
              title: 'Tanggal',
              dataIndex: 'dates_summary',
              key: 'dates_summary',
            },
            {
              title: 'Waktu',
              dataIndex: 'time_start',
              key: 'time_start',
              render: (time_start, field) => <>{time_start} - {field.time_end}</>,
            },
            {
              title: 'Total Harga Paket',
              dataIndex: 'price',
              key: 'price',
              render: (price, field) => <>{toRupiah(price)}</>,
            },
            {
              title: '',
              render: (field) => <>
                <Button type="primary" onClick={() => {
                  setSelectedBundling(dataSource.find(t => t.id == field.id));
                  modal.destroy();
                }}>Pilih</Button>
              </>,
            },
          ]}
        />
      </div>,
      okButtonProps: {
        style: { display: 'none' }
      },
    })
  }

  useEffect(() => {
    if (selectedTraining === null || selectedBundling === null)
      return
    const parsedSelected = parseIndoMultiMonth(selectedTraining.dates_summary);
    const parsedBundling = parseIndoMultiMonth(selectedBundling.dates_summary);
    const set2 = new Set(parsedBundling);
    const hasOverlap = parsedSelected.some(d => set2.has(d));
    setBundlingWarning(hasOverlap);
  }, [selectedBundling]);

  function parseIndoMultiMonth(str) {
    const months = {
      Januari: 0,
      Februari: 1,
      Maret: 2,
      April: 3,
      Mei: 4,
      Juni: 5,
      Juli: 6,
      Agustus: 7,
      September: 8,
      Oktober: 9,
      November: 10,
      Desember: 11,
    };

    const yearMatch = str.match(/\d{4}/);
    if (!yearMatch) return [];

    const year = parseInt(yearMatch[0]);

    // Hilangkan tahun
    const cleanStr = str.replace(yearMatch[0], "").trim();

    // Split berdasarkan koma
    const segments = cleanStr.split(",");

    const results = [];

    let month = null;
    for (let i = segments.length - 1; i >= 0; i--) {
      const segment = segments[i];
      const words = segment.trim().split(" ");

      if (words.length === 2) {
        // contoh: "28 Februari"
        month = months[words[1]];
      }
      const day = parseInt(words[0]);
      if (month)
        results.push(new Date(year, month, day));

      if (words.length === 3) {
        // contoh: "6 7 8 Maret" (jika tanpa koma)
        month = months[words[words.length - 1]];
        words.slice(0, -1).forEach(d => {
          results.push(new Date(year, month, parseInt(d)));
        });
      }
    }

    return results.map(d => d.toISOString().split("T")[0]);
  }

  return (
    <section className="ant-layout ant-layout-has-sider gx-app-layout">
      <main className="ant-layout-content gx-layout-content">
        <div className='gx-main-content-wrapper' style={{ "padding": "1em" }} id="alert-message">
          <div className="gx-app-login-wrap">
            <div className="gx-app-login-container">
              {showAlert && (
                <Alert
                  message={"Registrasi Berhasil"}
                  description={"Anda berhasil terdaftar dalam training, silahkan check email untuk melihat data akun dan jadwal training (check folder spam, promotions, dll)"}
                  type="success"
                  showIcon
                  closable={false}
                  action={
                    <Link to="/dashboard">
                      <Button type='primary'>Login</Button>
                    </Link>
                  }
                />
              )}
              <div className="gx-app-login-main-content">
                <div className="gx-app-logo-content" style={{ "backgroundColor": "#E13849" }}>
                  <div className="gx-app-logo-content-bg">
                    <img src="/bg-rg.jpg" style={{
                      "height": "auto",
                      "position": "absolute",
                      "left": 0,
                      "bottom": 0,
                    }} />
                  </div>
                  <div className="gx-app-logo-wid">
                    <h1>
                      Daftar
                    </h1>
                    <p>
                      Daftarkan diri kamu pada training terbaik dari kami
                    </p>
                  </div>
                  <div className="gx-app-logo">
                    <img
                      src="/assets/images/logo-idn.png"
                      width="150"
                    />
                  </div>
                </div>

                <div className="gx-app-login-content">
                  <Form
                    disabled={componentDisabled}
                    initialValues={{ remember: true, training_type: "online" }}
                    name="basic"
                    layout="vertical"
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    className="gx-signin-form gx-form-row0"
                    scrollToFirstError={true}
                    form={form}
                    onValuesChange={(changedValues, allValues) => {
                      onLocationChange()
                      if ("training_id" in changedValues) {
                        getAllRooms()
                        const training = trainings.find(
                          (t) => t.id === changedValues.training_id
                        );
                        setSelectedTraining(training);
                        setSelectedBundling(null);
                      }
                      if (
                        "training_option_id" in changedValues ||
                        "training_type" in changedValues ||
                        "training_location" in changedValues ||
                        "training_dates" in changedValues
                      ) {
                        onChangeTrainingsFilter({
                          training_option_id: allValues.training_option_id,
                          is_online: allValues.training_type === "online",
                          location:
                            allValues.training_type === "offline"
                              ? (allValues.training_location ? allValues.training_location : "XXXXXXXXXX")
                              : null,
                          start_date: allValues.training_dates ? allValues.training_dates.startOf("month").toISOString() : null,
                          end_date: allValues.training_dates ? allValues.training_dates.endOf("month").toISOString() : null,
                          status: "available",
                        })
                      }
                    }}
                  >
                    <p>
                      Form ini khusus bagi yg belum punya akun my.idn.id.
                      Jika kamu sudah punya silahkan <Link to="/sigin">login di sini</Link>.
                    </p>
                    <p>
                      Jika ada kendala pendaftaran, silahkan hubungi admin melalui <a href="https://wa.me/6281908191001?text=Saya%20ada%20kendala%20pendaftaran" target="_blank"
                        className="ant-btn ant-btn-sm ant-btn-info"
                        style={{ marginTop: "auto", marginBottom: "auto" }}>
                        <WhatsAppOutlined /> Whatsapp 081908191001
                      </a>
                    </p>
                    <Form.Item
                      label="Nama Lengkap"
                      rules={[{ required: true, message: "Harap masukan nama lengkap!" }]}
                      name="name"
                    >
                      <Input disabled={componentDisabled} />
                    </Form.Item>
                    <Form.Item
                      label="Nama Panggilan"
                      rules={[{ required: true, message: "Harap masukan nama panggilan!" }]}
                      name="nickname"
                    >
                      <Input disabled={componentDisabled} />
                    </Form.Item>
                    <Form.Item
                      rules={[{ required: true, message: "Harap pilih jenis kelamin!" }]}
                      name="gender"
                      label="Jenis Kelamin"
                    >
                      <Select disabled={componentDisabled}>
                        <Select.Option value={"male"}>Laki-laki</Select.Option>
                        <Select.Option value={"female"}>Perempuan</Select.Option>
                      </Select>
                    </Form.Item>
                    <Form.Item
                      label="Email"
                      name="email"
                      rules={[
                        {
                          required: true,
                          type: "email",
                          message: "Harap masukkan E-mail!",
                        },
                      ]}
                    >
                      <Input type='email' disabled={componentDisabled} />
                    </Form.Item>
                    <Form.Item
                      name="whatsapp_number"
                      label="Nomor whatsapp"
                      rules={[
                        {
                          required: true,
                          message: "Mohon masukkan nomor whatsapp!",
                        },
                      ]}
                    >
                      <PhoneInput
                        defaultCountry="ID"
                        style={{ width: "100%" }}
                        placeholder="081362778829"
                        disabled={componentDisabled}
                      />
                    </Form.Item>
                    <Form.Item
                      name="company"
                      label="Perusahaan"
                      rules={[
                        {
                          required: true,
                          message: "Mohon masukkan nama perusahaan!",
                        },
                      ]}
                    >
                      <Input disabled={componentDisabled} />
                    </Form.Item>
                    <Form.Item
                      name="job_position"
                      label="Jabatan / posisi di perusahaan"
                      rules={[
                        {
                          required: true,
                          message: "Mohon masukkan jabatan / posisi di perusahaan!",
                        },
                      ]}
                    >
                      <Input disabled={componentDisabled} />
                    </Form.Item>
                    <Form.Item
                      name="address"
                      label="Alamat tempat tinggal"
                      rules={[
                        {
                          required: true,
                          message: "Mohon masukkan alamat tempat tinggal!",
                        },
                      ]}
                    >
                      <Input.TextArea disabled={componentDisabled} />
                    </Form.Item>
                    <Form.Item
                      name="province"
                      label="Provinsi"
                      rules={[
                        {
                          required: true,
                          message: "Mohon masukkan provinsi tempat tinggal!",
                        },
                      ]}
                    >
                      <Select
                        placeholder="Pilih provinsi tempat tinggal"
                        disabled={componentDisabled}
                        showSearch
                        optionFilterProp="label"
                        options={provinces.map(province => {
                          return {
                            value: province,
                            label: province,
                          }
                        })}
                      />
                    </Form.Item>
                    <Form.Item
                      name="shirt_size"
                      label="Ukuran kaos"
                      rules={[
                        {
                          required: true,
                          message: "Mohon masukkan ukuran kaos!",
                        },
                      ]}
                    >
                      <Select
                        placeholder="Pilih ukuran kaos"
                        options={shirtSizes}
                        disabled={componentDisabled} />
                    </Form.Item>
                    <Form.Item
                      name="know_idn_from_where"
                      label="Tahu ID-Networkers darimana?"
                      rules={[
                        {
                          required: true,
                          message: "Mohon masukkan tahu dari mana!",
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        placeholder="Pilih"
                        disabled={componentDisabled}
                        optionFilterProp="label"
                        options={knowFrom.map(item => {
                          return {
                            value: item,
                            label: item,
                          }
                        })}
                      />
                    </Form.Item>
                    <Form.Item
                      label="Pilihan training"
                      name="training_option_id"
                      rules={[
                        { required: true, message: "Mohon pilih pilihan training" },
                      ]}
                    >
                      <Select
                        disabled={componentDisabled}
                        showSearch
                        placeholder="pilih pilihan training"
                        optionFilterProp="label"
                        options={trainingOptions.map(option => {
                          return {
                            value: option.id,
                            label: option.name,
                          }
                        })}
                      />
                    </Form.Item>
                    <p>
                      Info lengkap training silahkan cek di: <a target='_blank' href='https://www.idn.id/training'>www.idn.id/training</a>
                    </p>
                    <Form.Item label="Tipe training" name="training_type" required>
                      <Select disabled={componentDisabled}>
                        <Select.Option value="offline">Offline</Select.Option>
                        <Select.Option value="online">Online</Select.Option>
                      </Select>
                    </Form.Item>
                    <Form.Item shouldUpdate noStyle>
                      {
                        () => (
                          <Form.Item
                            label="Lokasi training"
                            name="training_location"
                            required
                            style={{
                              display:
                                form.getFieldValue("training_type") === "offline"
                                  ? "block"
                                  : "none",
                            }}
                          >
                            <Select
                              options={locations}
                              disabled={componentDisabled}
                              showSearch
                              optionFilterProp="label"
                            >
                            </Select>
                          </Form.Item>
                        )
                      }
                    </Form.Item>
                    <Form.Item label="Bulan training" name="training_dates" required>
                      <DatePicker picker="month" format="MMMM YYYY" allowClear={false} disabled={componentDisabled} />
                    </Form.Item>
                    <Form.Item
                      label="Jadwal training"
                      rules={[{ required: true, message: "mohon pilih jadwal training" }]}
                      name="training_id"
                    >
                      {trainings.length > 0 ? (
                        <Select
                          disabled={componentDisabled}
                          placeholder="pilih jadwal training"
                          showSearch
                          optionFilterProp="label"
                          options={trainings.map(option => {
                            return {
                              value: option.id,
                              label: option.dates_summary + " - " + toRupiah(option.price),
                            }
                          })}
                        />
                      ) : (
                        <>
                          {(form.getFieldValue("training_option_id") && ((form.getFieldValue("training_type") == "offline" && form.getFieldValue("training_location")) || form.getFieldValue("training_type") == "online") && form.getFieldValue("training_dates")) ? (
                            <Alert message={<span>Kuota sudah penuh atau jadwal belum tersedia di bulan yg anda pilih.<br />Silahkan pilih jadwal bulan berikutnya atau hubungi admin ID-Networkers via whatsapp 0819-0819-1001</span>}
                              type="info"
                              showIcon
                              action={
                                <a href="https://wa.me/6281908191001?text=Saya%20ada%20kendala%20pendaftaran" target="_blank"
                                  className="ant-btn ant-btn-sm ant-btn-info"
                                  style={{ marginTop: "auto", marginBottom: "auto" }}>
                                  <WhatsAppOutlined /> Whatsapp
                                </a>
                              } />
                          ) : (
                            <Alert message="Silahkan pilih Pilihan training, Tipe training, Lokasi training (jika offline), dan Bulan training terlebih dahulu."
                              type="info" />
                          )}
                        </>
                      )}
                    </Form.Item>
                    {(selectedTraining && selectedTraining.bundles.length > 0) && (
                      <Card
                        size="small"
                        hoverable
                      >
                        <Card.Meta
                          title="Training Bundling"
                          description="Bundle hemat: bayar lebih sedikit, belajar lebih banyak." />
                        <div style={{ marginTop: "1rem" }}>
                          {selectedBundling ? <>
                            <Space direction="vertical">
                              <Space size="middle" wrap>
                                <span>{selectedBundling.name}</span>
                                {selectedBundling.is_online ?
                                  <span style={{ color: "green" }}>ONLINE</span>
                                  :
                                  <span style={{ color: "blue" }}>OFFLINE</span>
                                }
                                <span>{selectedBundling.location && selectedBundling.location}</span>
                                <span>{selectedBundling.dates_summary}</span>
                                <span>{selectedBundling.time_start} - {selectedBundling.time_end}</span>
                                <span>{toRupiah(selectedBundling.price)}</span>
                                <Button
                                  type="primary"
                                  size="small"
                                  style={{ margin: 0 }}
                                  onClick={() => setSelectedBundling(null)}
                                >Batalkan</Button>
                              </Space>
                              {bundlingWarning &&
                                <Alert
                                  message="Tanggal training bundling ada yang sama dengan jadwal training yang dipilih. Apakah anda yakin?"
                                  type="warning"
                                  showIcon
                                  closable={false} />
                              }
                            </Space>
                          </> : <>
                            <Button type="primary" onClick={() => showBundlingOptions(selectedTraining.bundles)}>Pilih Bundling</Button>
                          </>}
                        </div>
                      </Card>
                    )}
                    {bookingShown && (
                      <>
                        <Form.Item
                          label="Apakah anda dari luar jakarta dan ingin booking kamar penginapan? (Khusus peserta training offline Jakarta dan khusus peserta laki-laki)"
                          valuePropName="checked"
                          name="want_to_book">
                          <Switch checkedChildren="Ya" unCheckedChildren="Tidak"
                            onChange={(v) => {
                              setWantToBook(v)
                            }} />
                        </Form.Item>
                        {wantToBook && (
                          <>
                            <Form.Item
                              label="Pilih Nomor Kasur (no.1-6 kasur bawah, no.7-12 kasur atas).
                Mohon maaf jika fasilitas seadanya"
                              name="room_number"
                              rules={[{ required: true, message: "Mohon pilih nomor kasur" }]}
                            >
                              <Radio.Group optionType="button" buttonStyle="solid" options={rooms.map((room => {
                                return {
                                  label: room.number,
                                  value: room.number,
                                  disabled: room.booked,
                                }
                              }))} onChange={(e) => {
                                form.setFieldsValue({ room_number: e.target.value })
                              }} />
                              <p>
                                Waktu Checkin : {checkInDate} jam 18.00 WIB<br />
                                Waktu Checkout : {checkOutDate} jam 13.00 WIB
                              </p>
                            </Form.Item>
                          </>
                        )}
                      </>
                    )}

                    <Form.Item shouldUpdate noStyle>
                      {() => (selectedBundling == null) && (<>
                        <Form.Item>
                          <a
                            href={() => false}
                            onClick={() => setShowAdvancedFields(!showAdvancedFields)}
                          >
                            {showAdvancedFields ? <UpOutlined /> : <DownOutlined />} Tampilkan
                            lebih {showAdvancedFields ? "sedikit" : "banyak"}
                          </a>
                        </Form.Item>
                        <div style={{ display: showAdvancedFields ? "block" : "none" }}>
                          <Form.Item noStyle shouldUpdate>
                            {() =>
                              !form.getFieldValue("is_retraining") && (
                                <>
                                  {/* <Form.Item
                                      name="affiliate_point"
                                      label="Gunakan Affiliate Point"
                                    >
                                      <Input type="number" placeholder="Contoh: 200" />
                                    </Form.Item> */}
                                  {!selectedBundling && (
                                    <Form.Item
                                      label="Kode Diskon (Pastikan klik tombol “Terapkan Kode”)"
                                      name="discount_id"
                                    >
                                      <Space wrap>
                                        <Input.Search
                                          placeholder="MASUKKAN KODE"
                                          enterButton={"Terapkan Kode"} // <SendOutlined />
                                          style={{ width: "300px" }}
                                          value={inputDiscountCode}
                                          onChange={(e) => setInputDiscountCode(e.target.value)}
                                          disabled={
                                            form.getFieldValue("training_option_id") === null ||
                                            form.getFieldValue("training_option_id") === undefined
                                          }
                                          onSearch={
                                            inputDiscountCode !== ""
                                              ? async () => {
                                                const result = await dispatch(
                                                  daftarDiscountChecker({
                                                    code: inputDiscountCode,
                                                    training_id:
                                                      form.getFieldValue("training_id"),
                                                  })
                                                );
                                                setDiscountPercent(result.percent);
                                                setDiscountPrice(result.price);
                                                setDiscountId(result.id);
                                              }
                                              : null
                                          }
                                        />
                                        {discountPercent !== null && (
                                          <Tag color="blue" style={{ margin: 0 }}>
                                            Diskon {discountPercent}%
                                          </Tag>
                                        )}
                                        {discountPrice !== null && (
                                          <Tag color="blue" style={{ margin: 0 }}>
                                            Diskon {toRupiah(discountPrice)}
                                          </Tag>
                                        )}
                                      </Space>
                                    </Form.Item>
                                  )}
                                  <Form.Item
                                    label="Kode Affiliasi (Pastikan klik tombol “Terapkan Kode”)"
                                    name="affiliate_code"
                                  >
                                    <Space wrap>
                                      <Input.Search
                                        placeholder="MASUKKAN KODE"
                                        enterButton={"Terapkan Kode"} // <SendOutlined />
                                        style={{ width: "300px" }}
                                        value={inputAffiliateCode}
                                        onChange={(e) => setInputAffiliateCode(e.target.value)}
                                        disabled={
                                          form.getFieldValue("training_option_id") === null ||
                                          form.getFieldValue("training_option_id") ===
                                          undefined ||
                                          discountPercent === 100
                                        }
                                        onSearch={
                                          inputAffiliateCode !== ""
                                            ? async () => {
                                              const result = await daftarAffiliateChecker({
                                                code: inputAffiliateCode,
                                                training_id:
                                                  form.getFieldValue("training_id"),
                                              });
                                              setAffiliatePercent(0);
                                              setAffiliateCode('');
                                              if (result) {
                                                setAffiliatePercent(5);
                                                setAffiliateCode(result.affiliate_code);
                                              }
                                            }
                                            : null
                                        }
                                      />
                                      {affiliatePercent !== 0 && discountPercent !== 100 && (
                                        <Tag color="blue" style={{ margin: 0 }}>
                                          Diskon {affiliatePercent}%
                                        </Tag>
                                      )}
                                    </Space>
                                  </Form.Item>
                                  <Form.Item shouldUpdate noStyle hidden>
                                    {() =>
                                      form.getFieldValue("already_paid") < 500000 && (
                                        <Form.Item
                                          label="Batas waktu pelunasan uang muka (Rp 500.000)"
                                          name="dp_deadline"
                                          rules={[{ required: true, message: "Mohon diisi" }]}
                                        >
                                          <DatePicker
                                            showTime
                                            format="dddd, DD MMMM YYYY [pukul] HH:mm"
                                            allowClear={false}
                                          />
                                        </Form.Item>
                                      )
                                    }
                                  </Form.Item>
                                </>
                              )
                            }
                          </Form.Item>
                        </div>
                      </>)}
                    </Form.Item>

                    <Form.Item
                      rules={[{ required: true, message: "Mohon untuk menyetujui peraturan training" }]}
                      name="rules_checked" valuePropName="checked" label={null}
                      onChange={(e) => {
                        if (e.target.checked)
                          form.setFieldsValue({ rules_checked: "checked" })
                        else
                          form.setFieldsValue({ rules_checked: null })
                      }}
                    >
                      <Checkbox disabled={componentDisabled}>Saya telah menyetujui peraturan training <a href="#" onClick={() => {
                        Modal.info({
                          title: "Peraturan Training",
                          centered: true,
                          width: 600,
                          closable: true,
                          icon: <CheckCircleOutlined />,
                          content: <div dangerouslySetInnerHTML={{ __html: rules }}></div>,
                          onOk: () => { },
                        })
                      }}>berikut ini</a></Checkbox>
                    </Form.Item>


                    <Form.Item>
                      <ReCAPTCHA
                        ref={recaptchaRef}
                        sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                        onChange={() => { }}
                        disabled={componentDisabled}
                      />
                    </Form.Item>
                    <Form.Item>
                      <Button
                        type="primary"
                        className="gx-mb-0 ant-btn-block"
                        htmlType="submit"
                        loading={componentDisabled}>
                        Klik Untuk Daftar
                      </Button>
                      {/* <span>
                        atau
                      </span>{" "}
                      <Link to="/signin">
                        Login
                      </Link> */}
                    </Form.Item>
                  </Form>
                </div>
                <InfoView />
              </div>
            </div>
          </div>
        </div>
      </main>
    </section>
  )
}

export default RegisterPage